import { Link } from 'react-router-dom'
import { DiceFive as Dice } from '@phosphor-icons/react'

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24 px-4 text-center space-y-6">
      <div className="w-20 h-20 rounded-2xl bg-primary border-2 border-edge shadow-brutal grid place-items-center">
        <Dice size={40} weight="fill" className="text-white" />
      </div>
      <div>
        <h1 className="font-heading font-black text-5xl tracking-tight mb-2">404</h1>
        <p className="text-xl font-bold text-ink-muted">Page not found</p>
      </div>
      <p className="text-ink-muted max-w-sm">
        This page doesn't exist — but your future still might. Head back and keep rolling.
      </p>
      <div className="flex gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-xl border-2 border-edge font-bold text-sm hover:bg-muted transition-all"
        >
          Home
        </Link>
        <Link
          to="/app"
          className="px-5 py-2.5 rounded-xl bg-primary text-white border-2 border-edge shadow-brutal-sm font-bold text-sm hover:-translate-y-0.5 hover:shadow-brutal transition-all"
        >
          My decisions
        </Link>
      </div>
    </div>
  )
}
